export enum AttachmentFileType {
  Image = 'file-image',
  Word = 'file-word',
  PDF = 'file-pdf',
  Other = 'file',
}
